import React, 
      { useEffect }        from 'react'
import Grid              from '@mui/material/Grid'
import Box               from '@mui/material/Box'
import Typography        from '@mui/material/Typography'
import Paper             from '@mui/material/Paper'
import Radio             from '@mui/material/Radio'
import RadioGroup        from '@mui/material/RadioGroup'
import FormControlLabel  from '@mui/material/FormControlLabel'
import ArrowForwardIcon  from '@mui/icons-material/ArrowForward'
import store             from '../../store'
import '../../App.css'
import '../../style.css'
import {GAMEMODE_ROOT_BOX_SX     ,
        GAMEMODE_SCREEN_PAPER_SX ,
        GAMEMODE_TITLE_TEXT_SX   ,
        GAMEMODE_SELECT_BOX_SX   ,
        GAMEMODE_MESSAGE_GRID_SX ,
        GAMEMODE_MESSAGE_TEXT_SX , } from '../Style/GameModeSelectStyle'

function GameModeSelect({ gameMode, setGameMode }) {
  // ラジオボタン変更時
  const handleRadioChange = (event) => {
    const value = event.target.value
    setGameMode(value)                    // 親 state 更新
    store.getState().GameModeSelect = value // 互換用に store にも反映
    console.log("選択中のラベル:", value)
  }

  useEffect(() => {
    console.log("選択中のゲームモード=>", gameMode)
  }, [gameMode])

  return (
    <Box sx={GAMEMODE_ROOT_BOX_SX}>
      {/* 画面 */}
      <Paper sx={GAMEMODE_SCREEN_PAPER_SX}>
        <Grid container spacing={0}>
          {/* タイトル表示 */}
          <Grid item xs={12} align="center">
            <Typography sx={GAMEMODE_TITLE_TEXT_SX}>
              ゲームモードせんたく
            </Typography>
          </Grid>

          {/* 選択欄表示 */}
          <Grid item xs={12} align="center">
            <Box sx={GAMEMODE_SELECT_BOX_SX}>
              <RadioGroup
                name="radio-buttons-group"
                value={gameMode}
                onChange={handleRadioChange}
              >
                <FormControlLabel 
                  value="kokugo" 
                  control={
                    <Radio 
                      icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                      checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                    />
                  }
                  label="こくご" 
                  sx={{ marginBottom: '-5px' }}
                  tabIndex={0}
                />
                <FormControlLabel 
                  value="sansuu" 
                  control={
                    <Radio 
                      icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                      checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                    />
                  }
                  label="さんすう" 
                  sx={{ marginTop: '-5px' }}
                  tabIndex={0}
                />
                <FormControlLabel 
                  value="zukan" 
                  control={
                    <Radio 
                      icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                      checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                    />
                  }
                  label="ずかんをみる" 
                  sx={{ marginTop: '-5px' }}
                  tabIndex={0}
                />
                <FormControlLabel 
                  value="typing" 
                  control={
                    <Radio 
                      icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                      checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                    />
                  }
                  label="タイピング" 
                  sx={{ marginTop: '-5px' }}
                  tabIndex={0}
                />
              </RadioGroup>
            </Box>
          </Grid>

          {/* メッセージ欄表示 */}
          <Grid 
            item xs={12} 
            align="center"
            sx={GAMEMODE_MESSAGE_GRID_SX}
          >
            <Typography
              sx={GAMEMODE_MESSAGE_TEXT_SX}
              tabIndex={0}
            >
              ゲームモードをえらんでね<br />
              1.↑↓でえらぶ<br />
              2.Aボタンでけってい
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <Grid container spacing={2}>
        <Grid item xs={12} align="center"></Grid>
      </Grid>
    </Box>
  )
}

export default GameModeSelect
